import React, {Component} from 'react';
import {Card, Col, Row} from 'reactstrap';

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export default class DataCard extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Card style={{padding: 10, minHeight: 200, borderRadius: 10}}>
        <Row>
          <Col xl={this.props.xl} md={this.props.md} lg={this.props.lg}>
            <div>
              <h4>{this.props.title || "set title"}</h4>
              <table style={{fontSize: 10, width: "100%"}}>
                <tbody>
                {(!this.props.data || this.props.data.length === 0) && (
                  <tr>
                    <td>{this.props.naMsg || "No Data"}</td>
                  </tr>
                )}
                {this.props.data.map((elem, index) => {
                  return <tr key={index}>
                    <td>{`${elem.name}`}</td>
                    <td>{elem.value}</td>
                  </tr>
                })}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DataCard.js